
























import { Vue, Component, Prop } from 'vue-property-decorator';
import ActionButtons from './ActionButtons.vue';

@Component({
  components: {
    ActionButtons,
  },
})
export default class CreateModal extends Vue {
  private editor: string = 'Tree';
  @Prop(Function) private confirmHandler: any;
  @Prop(Function) private cancelHandler: any;
  @Prop(Function) private metaChange: any;
  @Prop(Object) private metaValue: any;
  @Prop(Boolean) private isVisible!: boolean;
  @Prop(String) private hintText!: string;
  private mounted() {
    setTimeout(() => {
      if (this.editor === 'tree') {
        const { editor }: any = this.$refs.editorInstance;
        editor.expandAll();
      }
    }, 200);
  }
}
